var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2736 15.5445C16.4502 15.2387 16.4506 14.8651 16.2939 14.5481L12.2141 6.88014L14.9118 2.20762C15.3189 1.5025 15.0784 0.604675 14.3732 0.197571C13.6681 -0.209533 12.7703 0.0310382 12.3632 0.736163L9.66551 5.40868L0.985018 5.7095C0.736259 5.72039 0.499865 5.82102 0.319584 5.99277C0.139303 6.16452 0.0273403 6.39577 0.00441596 6.64371C-0.0185084 6.89165 0.0491571 7.1395 0.19489 7.34139C0.340624 7.54329 0.554559 7.68556 0.797105 7.74187L7.45832 9.23164L4.76064 13.9042L2.56929 14.1682C2.49323 14.1757 2.42016 14.2017 2.35637 14.2438C2.29259 14.2859 2.24001 14.3429 2.20319 14.4099L1.9138 14.9111C1.75194 15.1915 1.90608 15.5523 2.22208 15.6328L5.05399 16.339L7.08149 18.4384C7.30921 18.6718 7.69878 18.6249 7.86064 18.3445L8.15003 17.8433C8.18962 17.7779 8.2127 17.7039 8.21728 17.6276C8.22186 17.5513 8.2078 17.475 8.17631 17.4054L7.30928 15.3756L10.007 10.7031L14.6277 15.727C15.1024 16.2389 15.9303 16.1392 16.2736 15.5445Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.15c334286f7e54aa76ca052e8b838330.svg";
export { ForwardRef as ReactComponent };